import React from 'react';
import { Column } from 'new/elements/Table/types';
import { User } from 'new/entities/User';
import { TableProfile } from 'new/elements/TableProfile';

export const columns = [
  {
    name: 'Name',
    field: 'name',
    renderRow: (row) => {
      return <TableProfile name={row.full_name} />;
    },
  },
  {
    name: 'Email address',
    field: 'email',
  },
  {
    name: 'Shared resources',
    field: 'id',
  },
] as Column<User>[];
